import React, {useContext, useEffect, useState} from 'react';
import useFetch2 from "../../hooks/useFetch2";
import {Apis} from "../../util/data";
import {SelectV2} from "../forms/FormEl";
import {AuthContext} from "../../context/AuthContext";

const ConsejerosFormSelect = React.forwardRef((props, ref) => {

  const {user} = useContext(AuthContext)
  const {data, loading} = useFetch2(Apis.PROD + '/consejero_consejeria/list', []);
  const [selectedData,setSelectedData] = useState([])

  useEffect(() => {
    if(user?.tipoUsuario === 6) {
      setSelectedData(data.filter((consej)=>consej.id === user.id))
    } else setSelectedData(data)
  }, [user,data]);

  return (
    <>
      {
        !loading ?
          <SelectV2 ref={ref} options={selectedData} {...props}/>
          :
          <SelectV2 disabled options={[{id: 0, name: 'Cargando...'}]}/>
      }
    </>
  )
})

export default ConsejerosFormSelect;
